import React from 'react';
import LoadingSmall from '../../components/LoadingSmall.js';
import axios from 'axios';

class newinvoice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isBilling:false,
            error:false,
            billed:false,
            lines:[
                
            ],
        }

        this.line = this.line.bind(this);
        this.addNewLine = this.addNewLine.bind(this);
        this.removeLine = this.removeLine.bind(this);
        this.bill = this.bill.bind(this);
        this.outputValue = this.outputValue.bind(this);

        this.changeQty = this.changeQty.bind(this);
        this.changeDesc = this.changeDesc.bind(this);
        this.changePercent = this.changePercent.bind(this);
        this.changeExTax = this.changeExTax.bind(this);
        this.changeTotal = this.changeTotal.bind(this);
        this.formatValues = this.formatValues.bind(this);
    }

    formatValues() {
        this.setState({
            lines:this.state.lines.map(line => {
                line.amount_ex_tax = parseFloat(line.amount_ex_tax).toFixed(2)
                return line;
            })
        })
    }

    bill() {
        this.setState({
            isBilling:true
        });

        let data = {
            lines:this.state.lines,
            account_id:this.props.general.account.account_id
        }

        axios.post('/account/invoice',data).then(res => {
            this.setState({
                error:false,
                isBilling:false,
                billed:true,
            });
           window.open('https://app.crall.'+(location.hostname.split('.').pop() == 'dev' ? 'dev':'io')+'/'+this.props.general.account.account_id+'/invoices/'+res.data.stripe_id);
        }).catch(err => {
            this.setState({
                error:err.response.data.error.message,
                isBilling:false
            });
        });
    }

    changeQty(e,index) {
        this.updateLine(index,'quantity',parseInt(e.target.value));
    }

    changePercent(e,index) {
        this.updateLine(index,'tax_percent',parseInt(e.target.value));
    }

    changeExTax(e,index) {
        this.updateLine(index,'amount_ex_tax',e.target.value);
    }

    parseValue(val) {
        if(val.toString().slice(-1) == '.' || val.toString().slice(-1) == ',') {
            val = parseFloat(parseFloat(val).toString(2));
        }

        return parseFloat(val);
    }

    outputValue(val) {
        return parseFloat(val).toFixed(2);
    }

    changeTotal(e,index) {
        let val = e.target.value;

        if(this.state.lines[index].tax_percent > 0) {
            val = e.target.value/(1+(this.state.lines[index].tax_percent/100));
        }

        this.updateLine(index,'amount_ex_tax',val);
    }

    changeDesc(e,index) {
        this.updateLine(index,'description',e.target.value);
    }

    componentDidUpdate() {
        this.updateTotals();
    }

    updateTotals() {
        let totals = {
            total_ex_tax:0.00,
            total_inc_tax:0.00,
            total_tax:0.00,
        }

        this.state.lines.map(line => {
            let tax = 0;

            totals.total_ex_tax += parseFloat(line.amount_ex_tax);

            if(line.tax_percent == 0 || line.tax_percent == '') {
                totals.total_inc_tax += parseFloat(line.amount_ex_tax);
            }else{
                totals.total_inc_tax += parseFloat(line.amount_ex_tax)*(1+(line.tax_percent/100));
                tax = parseFloat(line.amount_ex_tax)*(1+(line.tax_percent/100))-parseFloat(line.amount_ex_tax);
            }

            totals.total_tax += tax;
        });

        return totals;
    }


    updateLine(index,key,value) {
        this.setState({
            lines:this.state.lines.map((line,i) => {
                if(i == index) {
                    line[key] = value;
                }
                return line;
            })

        })
    }


    addNewLine() {
        let line = {
            quantity:1,
            description:'',
            amount_ex_tax:100,
            tax_percent:25,
        }

        this.setState({
            lines:[
                ...this.state.lines,
                line,
            ]
        })
    }

    removeLine(index) {
        this.setState({
            lines:this.state.lines.filter((line,i) => i !== index)
        })
    }

    line(line,i) {
        let tax_percent = line.tax_percent;
        let total = line.amount_ex_tax;
        if(tax_percent > 0) {
            total = (line.amount_ex_tax*(1+(tax_percent/100)));
        }

        return (
            <tr key={i}>
                <td>
                    <input type="text" className="form-control" value={line.quantity} onChange={(e) => {this.changeQty(e,i)}}/>
                </td>
                <td>
                    <input type="text" className="form-control" value={line.description} onChange={(e) => {this.changeDesc(e,i)}} />
                </td>
                <td>
                    <input type="text" className="form-control" value={tax_percent} onBlur={this.formatValues} onChange={(e) => {this.changePercent(e,i)}} />
                </td>
                <td>
                    <input type="text" className="form-control" value={line.amount_ex_tax} onBlur={this.formatValues} onChange={(e) => {this.changeExTax(e,i)}} />
                </td>
                <td>
                    <input type="text" className="form-control" value={total} onBlur={this.formatValues} onChange={(e) => {this.changeTotal(e,i)}} />
                </td>
                <td style={{textAlign:'right'}}><button className="btn btn-danger" onClick={(e) => this.removeLine(i)}><i className="icon fa-trash"></i></button></td>
            </tr>
        );
    }

    render() {
        if(this.state.billed) {
            return <span>OK</span>
        }

        return (
            <div>
                <table className="table invoice">
                    <thead>
                        <tr>
                            <th>Qty</th>
                            <th>Description</th>
                            <th>Percent</th>
                            <th>Amount ex mva</th>
                            <th>Total</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.lines.map((line,i) => {
                                return this.line(line,i);
                            })
                        }
                        <tr>
                            <td colSpan={5}>&nbsp;</td>
                            <td style={{textAlign:'right'}}><button className="btn btn-success" onClick={this.addNewLine}><i className="icon fa-plus"></i></button></td>
                        </tr>
                        <tr>
                            <td colSpan={3}></td>
                            <td style={{textAlign:'right'}}>Tax</td>
                            <td style={{textAlign:'right'}}>{this.outputValue(this.updateTotals().total_tax)}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan={3}></td>
                            <td style={{textAlign:'right'}}>Total</td>
                            <td style={{textAlign:'right'}}>{this.outputValue(this.updateTotals().total_inc_tax)}</td>
                            <td></td>
                        </tr>

                        <tr>
                            <td colSpan={4}>
                                {this.state.error ?
                                    <div className="alert dark alert-danger">
                                        {this.state.error}
                                    </div>
                                    :null}
                            </td>
                            <td>
                                {
                                    this.state.isBilling ?
                                        <LoadingSmall/>
                                        :
                                        <button className="btn btn-success btn-block" onClick={this.bill}>Charge</button>
                                }
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default newinvoice;


// WEBPACK FOOTER //
// ./containers/adm/newinvoice.js